<template>
  <div
    class="q-wrap h5-wrap vh-q-sdk"
    :class="{ isReplayH5: isReplay }"
    v-show="show"
  >
    <div class="vhall-question-title" v-if="enable_banner != 0">
      <img :src="headerImg" alt="" />
    </div>
    <div v-if="config.showMyReward" style="text-align: right">
      <div @click.stop="handleMyReward" class="reward-button" v-on="$listeners">
        <i class="reward-button__icon"></i>
        <span class="reward-button__txt">{{ $t("form.form_1091") }} </span>
      </div>
    </div>
    <div class="q-title" v-text="q.title" v-if="q.title"></div>
    <div
      v-if="q.description"
      id="intro"
      :class="['q-des', overflowStatus == 1 ? 'introEllipsis' : '']"
    >
      {{ q.description }}
      <span
        @click="handleUnfold(2)"
        class="textTail"
        v-show="overflowStatus == 1"
      >
        <span class="isEllipsis">... </span>{{ $t("form.form_1011") }}
      </span>
      <span
        @click="handleUnfold(1)"
        class="textTail"
        v-show="overflowStatus == 2"
      >
        <span class="isEllipsis"></span>{{ $t("form.form_1012") }}
      </span>
    </div>
    <div class="q-split"></div>
    <div class="q-list">
      <com-question
        :ref="`com${index}`"
        v-for="(item, index) in q.detail"
        :detail="q.detail"
        :isReplay="isReplay"
        :value.sync="item"
        :key="index"
        >></com-question
      >
    </div>
    <!-- 隐私协议 -->
    <qPrivacy
      v-if="privacyDate.privacyConten"
      ref="qPrivacy"
      :privacyDate="privacyDate"
      :isPreview="true"
    ></qPrivacy>
    <div
      :class="['q-btns', showVhPrivacy ? 'q-btns__privacy' : '']"
      v-if="!config.isPreview & !isReplay"
    >
      <span @click="doSubmit" id="ques_sdk_sub_btn">{{
        $t("form.form_1045")
      }}</span>
    </div>
    <!-- 隐私协议 -->
    <!-- <div :class="['q-privacy', i18nLocal == 'en' ? 'language__en' : '']"
      v-if="showVhPrivacy">
      <i18n path="privacy.privacy_1002">
        <span place="n">
          <a :href="privacyUrl"
            target="_blank"
            rel="noopener noreferrer">
            {{ $t('privacy.privacy_1004') }}
          </a>
        </span>
        <span place="n1">
          <a :href="privacyUPoUrl"
            target="_blank"
            rel="noopener noreferrer">
            {{ $t('privacy.privacy_1003') }}
          </a>
        </span>
      </i18n>
    </div> -->
  </div>
</template>

<script>
import Questionnaire from "src/model/questionnaire";
import question from "../components/questionnaire/wrap.vue";
import CONST from "src/model/const";
import qPrivacy from "../components/q-privacy.vue";
import { PRIVACY_POLICY, PRIVACY_UPO } from "src/utils/conf";
import imgOperateMixin from "./mixins/img_operate";
export default {
  components: {
    comQuestion: question,
    qPrivacy,
  },
  mixins: [imgOperateMixin],
  provide() {
    return {
      sdk: this.sdk,
      defaultPhone: this.defaultPhone,
      isPreview: true,
      isH5: true,
      id: this.id,
      i18nLocal: this.i18nLocal,
      webinarId: this.webinarId,
      businessUid: this.businessUid,
    };
  },
  props: {
    id: [String, Number],
    sdk: Object,
    notify: Boolean,
    defaultPhone: [String, Number],
    config: {
      type: Object,
      default: {
        isPreview: false,
        isPc: true,
        showMyReward: false,
      },
    },
    showVhPrivacy: Boolean,
    i18nLocal: String,
    // 是否第三方提交问卷
    tpSubmit: {
      default: false,
    },
    webinarId: [Number, String],
    businessUid: [Number, String],
  },
  data() {
    return {
      show: false,
      overflowStatus: 0,
      defaultImg: require("./signup-form/form-head-new1.png"),
      q: new Questionnaire(),
      headerImg: "",
      privacyUrl: PRIVACY_POLICY,
      privacyUPoUrl: PRIVACY_UPO,
      privacyDate: {},
      enable_banner: true,
      isReplay: false,
    };
  },
  created() {
    if (this.id) {
      this.sdk.getById(this.id).then((res) => {
        if (res.code !== 200) {
          this.$emit(CONST.EVENT.ERROR, res);
          if (this.notify) {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          return;
        }
        this.q = new Questionnaire(res.data);
        console.log(this.q, "???w我是问卷sdk");
        console.log(this.q, this.config);
        let replayData = this.config.replayData;
        if (replayData && replayData.length > 0) {
          this.isReplay = true;
          for (let i = 0; i < replayData.length; i++) {
            for (let j = 0; j < this.q.detail.length; j++) {
              if (replayData[i].question_id == this.q.detail[j].id) {
                this.q.detail[j].replayData = replayData[i].answer;
                break;
              }
            }
          }
        } else {
          this.isReplay = false;
        }
        this.headerImg = this.imgOperate();
        this.$nextTick(() => {
          this.calculateText();
        });
        this.show = true;
        try {
          if (!res.data.extension) return;
          this.privacyDate = JSON.parse(res.data.extension);
          this.enable_banner = this.privacyDate.enable_banner;
          // undefined 为历史数据兼容
          if (
            this.privacyDate.privacyRadio == 1 ||
            this.privacyDate.privacyRadio == undefined
          ) {
            this.privacyDate.privacyConten = this.$t("privacy.privacy_1006");
            this.privacyDate.details = [
              {
                name: this.$t("privacy.privacy_1004"),
                url: PRIVACY_POLICY,
              },
              {
                name: this.$t("privacy.privacy_1003"),
                url: PRIVACY_UPO,
              },
            ];
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
  },
  methods: {
    async doSubmit() {
      let result = true;
      let data = {};
      let emitObj = {
        report: [],
      };
      // if(!this.$refs.qPrivacy.privacyChecked){
      //   result = false;
      //   this.$refs.qPrivacy.check();
      //   return false
      // }
      // 排除qPrivacy组件
      let keys = Object.keys(this.$refs).filter((item) => item != "qPrivacy");
      for (let i = 0, len = keys.length; i < len; i++) {
        let _data = await this.$refs[keys[i]][0].check();
        if (!_data) {
          const target = this.$refs[keys[i]][0].$el;
          target.scrollIntoView({
            behavior: "smooth",
          });
          result = false;
          break;
        }
        if (_data.id) {
          if (_data.keyVal) {
            data[_data.id] = _data.keyVal;
          } else {
            data[_data.id] = _data.value;
          }
          // 其他选项
          if (_data.otherValue) {
            data[_data.keyVal || _data.value] = _data.otherValue;
          }
          emitObj.report.push(_data);
          console.log(data);
        }
      }
      if (result) {
        let _data = {
          naire_id: this.id,
          id: this.id,
          answer: JSON.stringify(data),
        };
        console.log(emitObj, 88);
        // 如果是第三方提交，则只负责抛出消息
        if (this.tpSubmit) {
          this.$emit(CONST.EVENT.SUBMIT, _data);
          return;
        }
        this.sdk
          .submit(_data)
          .then((res) => {
            if (res.code === 200) {
              // 提交的时候除了返回参数还要是返回接口返回值
              this.$emit(
                CONST.EVENT.SUBMIT,
                Object.assign(_data, emitObj, res || {})
              );
              // if (this.notify) {
              //   this.$notify({
              //     message: '提交成功',
              //     type: 'success'
              //   });
              // }
            } else {
              this.$emit(CONST.EVENT.ERROR, res);
              if (this.notify) {
                // this.$notify.error({
                //   message: '提交失败'
                // });
              }
            }
          })
          .catch((error) => {
            this.$emit(CONST.EVENT.ERROR, error);
            // if (this.notify) {
            // this.$notify.error({
            //   message: '服务器端错误'
            // });
            // }
          });
      }
    },
    handleUnfold(val) {
      this.overflowStatus = val;
    },
    calculateText() {
      const txtDom = document.getElementById("intro");
      if (!txtDom) return false;
      const twoHeight = 40;
      const curHeight = txtDom.offsetHeight;
      if (curHeight > twoHeight) {
        this.overflowStatus = 1;
      }
    },
    // 互动有礼，查看我的礼品
    handleMyReward() {
      this.$emit(CONST.EVENT.MYREWARD);
    },
  },
};
</script>

<style scoped lang="scss">
.q-wrap {
  width: 100%;
  font-size: 16px;
  background-color: #fff;
  .vhall-question-title {
    width: 100%;
    height: 60px; // 与pc一样的比例
    border-radius: 4px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
  .q-btns span {
    border: 1px solid #fb3a32;
    background-color: #fb3a32;
    font-size: 14px;
    color: #fff;
    outline: none;
    display: block;
    width: calc(100% - 40px);
    height: 40px;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    margin: 20px auto;
  }
  .index {
    line-height: 14px;
  }
  ::v-deep {
    * {
      box-sizing: border-box;
    }
    .index {
      line-height: 14px;
    }
    .com-input {
      .limit.area {
        transform: none;
        bottom: -20px;
      }
      input {
        transform: translate3d(0, 0, 0) !important;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
    }
    .q-title {
      text-align: center;
      font-size: 20px;
      word-break: break-all;
      line-height: 22px;
      color: #333;
      padding: 18px 20px;
    }
    .q-des {
      text-align: left;
      font-size: 16px;
      margin: 0px 20px;
      word-break: break-all;
      line-height: 18px;
      position: relative;
      &.introEllipsis {
        min-height: 36px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
        -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
        -webkit-line-clamp: 2; /** 显示的行数 **/
        overflow: hidden; /** 隐藏超出的内容 **/
      }
      .textTail {
        position: absolute;
        bottom: 0px;
        right: 0px;
        cursor: pointer;
        background-color: #fff;
        color: #3562fa;
        .isEllipsis {
          color: #666666;
        }
      }
    }
    .q-split {
      margin-bottom: 15px;
    }
    .question-wrap {
      border: 0;
    }
    .q-btns {
      width: 100%;
      line-height: 100px;
      height: 100px;
      text-align: center;
      font-size: 12px;
      &.q-btns__privacy {
        line-height: unset;
        height: unset;
        span {
          margin: 20px auto 12px auto;
        }
      }
    }
    // .q-privacy {
    //   margin: 0 auto 60px auto;
    //   padding: 0 20px;
    //   text-align: left;
    //   span,
    //   a {
    //     font-style: normal;
    //     font-weight: 400;
    //     font-size: 12px;
    //     line-height: 16px;
    //     color: #8c8c8c;
    //     word-break: break-word;
    //   }
    //   a {
    //     text-decoration: none;
    //     font-weight: 400;
    //     color: #3562fa;
    //     transform: matrix(0.99, 0, -0.14, 1, 0, 0);
    //     &:hover {
    //       color: #3562fa;
    //     }
    //   }
    //   &.language__en {
    //     text-align: center;
    //     a {
    //       font-style: italic;
    //     }
    //   }
    // }
    @media (min-width: 375px) {
      .q-privacy {
        text-align: center;
      }
    }
    .question-content {
      .index {
        position: relative;
        top: 2px;
        font-size: 14px;
      }
      .q-edit .q-subject {
        font-size: 14px;
      }
      .com-input {
        height: 40px;
      }

      .vh-date-editor.vh-input {
        width: 100%;
      }
      .q-edit-content .q-select-item {
        width: 100%;
        position: relative;
        display: flex;
        min-height: 40px;
        padding: 10px 0px;
        align-items: center;
        flex-direction: row-reverse;
        margin-top: 10px;
        border: 1px solid #d2d2d2;
        margin-bottom: 0px;
        border-radius: 4px;
      }
      .vh-radio__input {
        margin-top: 0px;
        margin-right: 10px;
      }
      .q-edit-content .item-text {
        flex: 1;
        font-size: 12px;
        margin-top: 0px;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
        font-weight: 400;
        line-height: 18px;
      }
      .vh-radio__label {
        flex: 1;
        padding-left: 10px;
      }
      .q-select-item .vh-checkbox__input {
        margin-top: 0px;
        margin-right: 10px;
      }
      .q-select-item .vh-checkbox__label {
        flex: 1;
      }
      .error-msg {
        position: initial;
        color: #fc5659;
        top: 0px;
      }
    }
  }
}
::v-deep {
  .select {
    width: 100%;
    .vhall-inline {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.h5-wrap {
  .q-edit-content .q-select-item .vh-checkbox__label {
    padding-left: 10px;
  }
}
.h5-wrap.isReplayH5 {
  .vh-radio__input.is-disabled + span.vh-radio__label,
  .vh-checkbox__input.is-disabled + span.vh-checkbox__label {
    color: #c2c2c2;
  }
  .vh-input.is-disabled .vh-input__inner {
    background-color: #fff;
    color: #c2c2c2;
  }
}
</style>
<style lang="scss" scoped>
.reward-button {
  margin-top: 10px;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 5px 8px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: #fff;

  &__icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHtSURBVHgB7ZqBcYIwFIb/eB3ATtBsUDeoHaEb2AnqBtIJtBNoN3ADdQLdQDbQDV5fDqgQIyDWyLP57v5Dj4S8nyQ8SQQCgcDdQUQ9lm5Qp4e2w0GO6cCoZp1prs4QbYaOGVWUn1rl52gzHOCirkmHORE92GWtq0yeMBdBAlUmRZvLKDG5Fm8uo8SkN3Oq7CQleenS3NRljdKjzYb1hcvYGymllrVrUJJ0tySLLWtge1EOc5oPa7jvuATeuDd/c2nHUSCCXHOGQjp6cBR4zn2OWZ9oPx84PCvM9OpyL+6dJak49xYQAMc5s+ajzs51cOdUGZQyF0/G6ZqDMUunn814JsjC5MQ4++LqwW/Ipjp+7rSIZLJgFYarKjHZ58OA9cTq506Zx+8G52Mazv/si1Odi8ZhCiGNxWjFQ3OGJlh3aYoGmBtmXSdCA+h4dPXLyv/7NCGeYFA6waB0gkHpBIPSCQal49OgvQgUwwPeDPKrTH4Ve5nq6ngdomxyqBJe88sK1yTMQekEg9IJBh084t6g4obMzl579ByLvSV+eSx8kYl1UdOIhkco2e8f23FU1VOoAZ3e9V3CD6ZdjeP23xsv9tqwySG1iwn+GkpM7uj21DZXa4haJjWSPYsXFPcIro15G1mx5mf9ZSQQCNyUHxPwr3gxpTnCAAAAAElFTkSuQmCC");
  }

  &__txt {
    font-size: 14px;
    margin-left: 4px;
  }
}
</style>
